import * as tslib_1 from "tslib";
import { filter, pairwise, switchMap, } from 'rxjs/operators';
import { NullableStateManager, StateManager, } from './state-manager';
var watchUser = function (user, fetch, clean) {
    user.value$
        .pipe(pairwise(), filter(function (_a) {
        var prevUser = _a[0], nextUser = _a[1];
        return !prevUser || !nextUser;
    }), switchMap(function (_a) {
        var prevUser = _a[0];
        return prevUser ? clean() : fetch();
    }))
        .subscribe();
};
var ɵ0 = watchUser;
/**
 * A NullableStateManager that reacts to user log in and log out actions.
 */
var UserStateManager = /** @class */ (function (_super) {
    tslib_1.__extends(UserStateManager, _super);
    function UserStateManager(user) {
        var _this = _super.call(this) || this;
        watchUser(user, function () { return _this.fetch(); }, function () { return _this.clean(); });
        return _this;
    }
    return UserStateManager;
}(NullableStateManager));
export { UserStateManager };
/**
 * An ExtendedUserStateManager that is similar to a UserStateManager, but its state is never null,
 * indicating that it may also have limited functionality when the user isn't logged in.
 */
var ExtendedUserStateManager = /** @class */ (function (_super) {
    tslib_1.__extends(ExtendedUserStateManager, _super);
    function ExtendedUserStateManager(user) {
        var _this = _super.call(this) || this;
        watchUser(user, function () { return _this.fetch(); }, function () { return _this.clean(); });
        return _this;
    }
    return ExtendedUserStateManager;
}(StateManager));
export { ExtendedUserStateManager };
export { ɵ0 };
